import { render, staticRenderFns } from "./PortfolioFrontPagePreview.vue?vue&type=template&id=525d051a&scoped=true"
import script from "./PortfolioFrontPagePreview.vue?vue&type=script&lang=js"
export * from "./PortfolioFrontPagePreview.vue?vue&type=script&lang=js"
import style0 from "./PortfolioFrontPagePreview.vue?vue&type=style&index=0&id=525d051a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d051a",
  null
  
)

export default component.exports